import React, { useRef, useState } from "react";
import * as IoIcons from "react-icons/io";
import "../estilos.css";
import { Row, Label, odal, ModalHeader, ModalBody, ModalFooter, Modal, Button, Input } from "reactstrap";
import { Table, Thead, Tbody, Tr, Th, Td } from "react-super-responsive-table";
import QRGenerator from "../codereader/Qrgenerator";
import { useReactToPrint } from "react-to-print";
import { decodificarComentariosPPB, ObtenerDCargaPProduccion, ObtenerDInspeccionFPProduccion, ObtenerDPintadoPProduccion } from "../queries/DCUbicaciones";
import { GetPlaneacionBaseGeneralID, GetPlaneacionBaseID } from "../queries/Queries";
import moment from "moment";
import { updatePlaneacionBase, updatePlaneacionBaseGeneral } from "../../graphql/mutations";
//import { API } from "aws-amplify";
import { generateClient } from "aws-amplify/api";

const API = generateClient();

function CometariosPB({
  planeacion,
  bColor,
  btitle,
  userName,
  tipo, //PB ->Planeación | base PP->Producción | Todo
  valorDeRetorno
}) {

  const [comentarioPB, setComentarioPB] = useState("");
  const [comentarioPP, setComentarioPP] = useState("");
  const [modal3, setModal3] = useState(false);
  const [cargando, setCargando] = useState(false);
  const toggle3 = () => setModal3(!modal3);


  async function verDetalles() {
    setComentarioPB(planeacion.comentarios ? planeacion.comentarios : "");
    setComentarioPP(planeacion.comentariosProduccion ? planeacion.comentariosProduccion : "");
    toggle3();
  }

  async function guardarComentarios() {
    setCargando(true);
    try {
      if (planeacion.prioridadAtencion === "Sin planificar") {
        if (planeacion.planeacionGeneralID) {
          const fechaOpreacion = moment(new Date).format("YYYY-MM-DD HH:mm");
          const rPPlaneacion = await GetPlaneacionBaseGeneralID(planeacion.planeacionGeneralID);
          const comentariosDeCod = rPPlaneacion.comentarios ? await decodificarComentariosPPB(rPPlaneacion.comentarios) : [];
          var datosComentarios = comentariosDeCod;
          const coment = comentariosDeCod.filter(np => np.cliente === planeacion.cliente && np.numerodeParte === planeacion.numerodeParte);
          if (coment.length > 0) {
            await Promise.all(datosComentarios.map(async (comentPBSP) => {
              if (comentPBSP.cliente === planeacion.cliente && comentPBSP.numerodeParte === planeacion.numerodeParte) {
                comentPBSP.comentarioPB = comentarioPB;
                comentPBSP.comentarioPP = comentarioPP;
                comentPBSP.Reg_Mod_Usuario = userName;
                comentPBSP.Reg_Mod_Fecha = fechaOpreacion;
              }
              return comentPBSP;
            }));
          } else {
            datosComentarios.push({
              cliente: planeacion.cliente, numerodeParte: planeacion.numerodeParte,
              comentarioPB: comentarioPB, comentarioPP: comentarioPP, Reg_Ins_Usuario: userName,
              Reg_Ins_Fecha: fechaOpreacion, Reg_Mod_Usuario: userName, Reg_Mod_Fecha: fechaOpreacion
            });
          }

          rPPlaneacion.comentarios = datosComentarios;
          delete rPPlaneacion.createdAt;
          delete rPPlaneacion.updatedAt;
          delete rPPlaneacion.__typename;
          //setMensajeAlert("Problemas al actualizar el planeación general 2 " + JSON.stringify(rPPlaneacion));
          await API.graphql({
            query: updatePlaneacionBaseGeneral, variables: { input: rPPlaneacion }
          });
        }
      } else {
        if (planeacion.id) {
          const planeacionA = await GetPlaneacionBaseID(planeacion.id);
          delete planeacionA.createdAt;
          delete planeacionA.updatedAt;
          delete planeacionA.__typename;
          planeacionA.Reg_Mod_Usuario = userName;
          if (tipo === "Todo" || tipo === "PP") {
            planeacionA.comentariosProduccion = comentarioPP;
          }
          if (tipo === "Todo" || tipo === "PB") {
            planeacionA.comentarios = comentarioPB
          }
          //setMensajeAlert("Problemas al actualizar el registro en planeación " + JSON.stringify(planeacionA));
          let resultadoc = await API.graphql({ query: updatePlaneacionBase, variables: { input: planeacionA } });
        }
      }
      setCargando(false);
      valorDeRetorno({ completo: true, mensaje: "Operación exitosa; comentarios guardados satisfactoriamente", color: "primary" });
      toggle3();
    } catch (e) {
      valorDeRetorno({ completo: true, mensaje: "Error al guardar los datos", color: "warning" });
      toggle3();
    }
  }

  return (
    <>
      <Row>
        {cargando === true && (
          <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 ">
            <img width="150px" src="assets/img/preloader.gif" />
          </div>
        )}
      </Row>
      {cargando === false && (
        <button
          class={"btn-" + bColor + " cbutton"}
          title={btitle}
          //style={{ display: "none" }}
          onClick={() => verDetalles()}
        >
          <IoIcons.IoIosChatbubbles />
        </button>
      )}
      <Modal isOpen={modal3} toggle={toggle3} size="lg" >
        <ModalHeader toggle={toggle3}>
          Comentarios de planeación base
        </ModalHeader>
        <ModalBody>
          <Row>
            {cargando === true && (
              <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 ">
                <img width="150px" src="assets/img/preloader.gif" />
              </div>
            )}
            <div className={" col-lg-12 col-md-12 col-sm-12 col-xs-12 "}>
              <h5 class=""> Datos generales</h5>
              <Table className="mb-2 scroll ">
                <Thead class="thead-secondary">
                  <Tr>
                    <Th className="minwidth200px">Cliente</Th>
                    <Th className="minwidth100px">Número de parte</Th>
                    <Th className="minwidth100px">Descripción</Th>
                    <Th className="minwidth100px ">Cantidad planeada</Th>
                  </Tr>
                </Thead>
                <Tbody>
                  <Tr >
                    <Td className="margintopmobil20px">{planeacion.cliente}</Td>
                    <Td className="margintopmobil20px">{planeacion.numerodeParte}</Td>
                    <Td className="margintopmobil20px">{planeacion.descripcion}</Td>
                    <Td className="margintopmobil20px">{planeacion.cantidadPiezas} </Td>
                  </Tr>
                </Tbody>
              </Table>
            </div>
          </Row>
          {(tipo === "Todo" || tipo === "PB") && (

            <Row>
              <div className={" col-lg-12 col-md-12 col-sm-12 col-xs-12 margintop20px "}>
                <h5>Comentarios de Planeación Base</h5>
              </div>
              <div className={" col-lg-12 col-md-12 col-sm-12 col-xs-12  "}>
                <Input name="comentarios PB"
                  type="textarea"
                  rows="3"
                  value={comentarioPB}
                  onChange={e => setComentarioPB(e.target.value)} placeholder="" />
              </div>
            </Row>
          )}
          {(tipo === "Todo" || tipo === "PP") && (
            <Row>
              <div className={" col-lg-12 col-md-12 col-sm-12 col-xs-12  margintop20px"}>
                <h5>Comentarios de Producción</h5>
              </div>
              <div className={" col-lg-12 col-md-12 col-sm-12 col-xs-12  "}>
                <Input name="comentarios PB"
                  type="textarea"
                  rows="3"
                  value={comentarioPP}
                  onChange={e => setComentarioPP(e.target.value)} placeholder="" />
              </div>
            </Row>
          )}
        </ModalBody>
        <ModalFooter>
          <Button color="primary" onClick={guardarComentarios}>Guardar</Button>
          <Button color="danger" onClick={toggle3}>
            Cerrar
          </Button>
        </ModalFooter>
      </Modal>
    </>
  );
}
export default CometariosPB;
